import React from 'react';
import '../../styles/leasewise/base.css';
import '../../styles/leasewise/base_component.css';

// Mobile-first page container for ported LeaseWise screens. Scopes all
// ported CSS under the .lw class so it can't collide with the Tailwind app.
// On desktop, centers a phone-width column per the reference's mobile layout.
export function LwShell({ children }) {
  return (
    <div className="lw">
      <div className="mx-auto w-full max-w-md min-h-screen bg-white">
        {children}
      </div>
    </div>
  );
}

export default LwShell;
